import React from 'react'
import { useTranslation } from 'react-i18next'
import { AppButton } from '@/components/AppButton'
import {
  isAndroid,
  supportsAppleWallet,
  supportsGoogleWallet,
} from '@/utils/platformDetection'

const openAppleWallet = async () => {
  const walletDeepLink = 'wallet://'

  try {
    // In web environment, we can't directly open the wallet app
    // Instead, we'll show instructions or redirect to App Store
    window.open('https://apps.apple.com/app/wallet/id1160481993', '_blank')
  } catch (error) {
    console.error('Failed to open Apple Wallet:', error)
  }
}

const openGoogleWallet = async () => {
  const googleWalletDeepLink = 'https://www.android.com/payapp/'

  try {
    window.open(googleWalletDeepLink, '_blank')
  } catch (error) {
    console.error('Failed to open Google Wallet:', error)
  }
}

export const OpenWalletButton: React.FC<{ platform: 'apple' | 'google' }> = ({
  platform,
}) => {
  const { t } = useTranslation()

  const handlePress = () => {
    if (platform === 'google') {
      openGoogleWallet()
    } else {
      openAppleWallet()
    }
  }

  // Don't show the button if the platform doesn't support wallets
  if (!supportsAppleWallet() && !supportsGoogleWallet()) {
    return null
  }

  return (
    <AppButton
      type="tertiaryWhite"
      label={t(
        platform === 'google'
          ? 'screens:kemCard.walletInstructions.openGoogleWallet'
          : 'screens:kemCard.walletInstructions.openAppleWallet',
      )}
      onPress={handlePress}
      style={{ marginTop: 'auto' }}
    />
  )
}
